<div class="version-overlay" *ngIf="showPopup">
    <div class="version-card">
        
        <div class="v-header">
            <h3>Update Required</h3>
            <!-- <h3>{{ 'GUI.Titles.UpdateRequired' | translate }}</h3> -->
        </div>

        <div class="v-body">
            <p>A New Version is Available. The Application Will Now Reload</p>
            <!-- <p>{{ 'GUI.errorMessages.NewVersionAvailable' | translate }}</p> -->
            
            <button #updateBtn class="update-btn" (click)="forceReload()">
                Reload Now
                <!-- {{ 'GUI.Buttons.UpdateNow' | translate }} -->
            </button>

            <div class="auto-reload-text">
                Auto reloading in <strong>{{ secondsRemaining }}</strong> seconds
            </div>

        </div>

    </div>
</div>